/**
 * API Configuration
 * Centralized API URL configuration for the application
 */


// Automatically detect environment
const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// // // // Use production API URL for live server, localhost for development
// export const API_BASE_URL = isDevelopment
//   ? 'http://localhost:5000/api/v1'
//   : 'https://api.visibeen.com/api/v1';


// export const API_BASE_URL = 'https://api.visibeen.com/api/v1';
export const API_BASE_URL = 'https://api.visibeen.com/api/v1';


//  'http://localhost:5000/api/v1'
// 'https://api.visibeen.com/api/v1';

// For serving static files (uploads, images, etc.)'
export const API_SERVER_URL = 'https://api.visibeen.com';

// For serving static files (uploads, images, etc.)
// export const API_SERVER_URL = isDevelopment
//   ? 'http://localhost:5000'
//   : 'https://api.visibeen.com';



export default {
  API_BASE_URL,
  API_SERVER_URL
};

// Debug: print which API base is in use at runtime
try {
  // window is available in browser context
  console.log('🌐 API_BASE_URL in use:', API_BASE_URL, '| isDevelopment:',
    (window && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')),
    '| hostname:', (window && window.location && window.location.hostname));
} catch (_) {
  // no-op if window is not defined
}